import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { jsx as _jsx } from "react/jsx-runtime";
export function TLinkButton(props) { return /*#__PURE__*/ _jsx(Link, { to: props.to, style: { textDecoration: "none" }, children: /*#__PURE__*/ _jsx(Button, { startIcon: props.startIcon, variant: props.variant || "text", size: props.size || "small", color: "primary", children: props.title }) }); }
